import React from 'react'
import FormInput from '../../../../../library/form/components/FormInput';
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormROValue from '../../../../../library/form/components/FormROValue1';

const ProdIOOExiCMNEditor = (props) => {
    const { formObject } = props;

    return (
        <>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "actualItem" }} value="Selected Item" />
                </span>
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "actualItem" }}/>
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyRequired1" }} value="Req Qty 1" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" 
                    action={{ InputType: "input", actionId: "refresh", paramName: "qtyRequired1", actionParam:{"formulaSource":"req", "updateQty":1} }}
                    className='uiSpacerH10'/>
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "unit1" }} className="uiSpacerH10"/>
                <span className="uiLblInLine">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyRequired2" }} value="Req Qty 2" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey=""
                    action={{ InputType: "input", actionId: "refresh", paramName: "qtyRequired2", actionParam:{"formulaSource":"req", "updateQty":1} }} className='uiSpacerH10'/>
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "unit2" }}/>
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyAllocated1" }} value="Alloc Qty 1" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "qtyAllocated1" }} className='uiSpacerH10'/>
                <FormROValue formObject={formObject} rowKey="" 
                action={{ paramName: "unit1", actionParam:{"updateQty":1} }} className="uiSpacerH10"/>
                <span className="uiLblInLine">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyAllocated2" }} value="Alloc Qty 2" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "qtyAllocated2" }} className='uiSpacerH10'/>
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "unit2" }} />
            </li>
        </>
    )
}

export default ProdIOOExiCMNEditor;
